var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Menu'),_c('topBlock',{attrs:{"title":_vm.title}}),_c('simpleTable',{staticClass:"main-table",attrs:{"tableData":_vm.tableData}}),_c('div',{staticClass:"wrap"},[_c('todolist')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }